<script>
  import { _, language } from "../stores/index";
  import { isValidName } from "../utils/validators";
  import {
    Button,
    Flex,
    FlexItem,
    Callout,
    Text,
    Icon,
    Modal,
    TextField,
    Submit,
    Form,
    Checkbox,
    Flatpickr,
  } from "@gl/design-system";
  import { faCheck, faCopy } from "@fortawesome/pro-regular-svg-icons";
  import { UsersRepository } from "../repositories/index";
  const dispatch = createEventDispatcher();
  import { createEventDispatcher } from "svelte";
  import { addMonths, format, addDays, startOfDay } from "date-fns";

  export let userId;
  export let active;

  let loading = false;

  let token;

  const now = new Date();
  const nowPlus3months = addMonths(now, 3);

  let form = { hasExpiration: true, expiration: nowPlus3months.toISOString() };

  async function addKey() {
    try {
      loading = true;
      const expirationISOS = form.hasExpiration
        ? new Date(form.expiration).toISOString()
        : null;
      const result = await UsersRepository.generateToken(userId, {
        name: form.name,
        expiration: expirationISOS,
      });
      token = result.token;
      form.expirationISOS = expirationISOS;
    } finally {
      loading = false;
    }
  }
</script>

<Modal bind:active on:close boxed>
  <div class="gl-title mb-4">{$_("users.new.key")}</div>

  {#if token}
    <Callout status="success" class="mt-4" id="users-success-callout">
      <Icon icon={faCheck} />
      <Text>{$_("users.key.success")}</Text>
    </Callout>
    <p class="color-info mt-2 mb-4" style="font-size: 14px;">
      {$_("users.key.success.subtext")}
    </p>

    <Flex class="align-items-center mb-3 mt-5">
      <p
        class="gl-title"
        style={`color: ${token ? "var(--gl-text)" : "var(--gl-error)"}; font-size: 16px;`}
      >
        {$_("users.api.key")}
      </p>
      {#if form.hasExpiration && form.expirationISOS}
        <p class="color-error ml-2">
          {$_("users.key.expire.on")}: {format(
            new Date(form.expirationISOS),
            "dd.MM.yyyy",
          )}
        </p>
      {/if}
    </Flex>

    <Flex>
      <div class="copy-field mr-3">{token || ""}</div>
      <FlexItem pushEnd={true}>
        <Button
          on:click={() => navigator.clipboard.writeText(token)}
          outlined
          size="tiny"
          disabled={!token}
          style="height:100%"
        >
          <Text>{$_("common.copy")}</Text>
          <Icon icon={faCopy} />
        </Button>
      </FlexItem>
    </Flex>

    <div class="mt-6 mb-0">
      <Button outlined on:click={() => dispatch("close")}>
        {token ? $_("buttons.close") : $_("buttons.cancel")}
      </Button>
    </div>
  {:else}
    <Form validationMode="eager">
      <TextField
        bind:value={form.name}
        label={$_("common.name")}
        required={$_("validations.required")}
        validate={(value) => isValidName(value, 20)}
        maxLength={20}
        config={{ characterCount: $_("character.count") }}
      />

      <div class="expiration">
        <Checkbox
          bind:value={form.hasExpiration}
          label={$_("expiration.set")}
        />
        {#if form.hasExpiration}
          <div class="ml-4">
            <Flatpickr
              bind:value={form.expiration}
              format="d.m.Y"
              placeholder="DD.MM.YYYY"
              language={$language}
              showTime={false}
              minDate={startOfDay(addDays(new Date(), 1)).toISOString()}
            />
          </div>
        {/if}
      </div>

      <div class="mt-6 mb-0">
        <Submit on:submit={addKey} {loading} label={$_("buttons.create")} />

        <Button outlined on:click={() => dispatch("close")}>
          {token ? $_("buttons.close") : $_("buttons.cancel")}
        </Button>
      </div>
    </Form>
  {/if}
</Modal>

<style>
  .copy-field {
    background-color: var(--gl-background);
    border-radius: 4px;
    border: 1px solid var(--gl-border);
    min-height: 38px;
    max-width: 85%;
    line-break: anywhere;
    padding: 8px;
  }

  .expiration {
    display: flex;
    align-items: center;
  }

  .expiration :global(.gl-form-block) {
    margin-bottom: 0;
  }
</style>
